
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { BaseIconComponent } from '../../private/base-icon/base-icon.component';

@Component({
  selector: 'icon-calendar-today',
  imports: [],
  templateUrl: './calendar-today-icon.component.html',
  styleUrl: '../styles.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalendarTodayIconComponent extends BaseIconComponent {}
